import { FormLayout, InputField } from '@app/lib/form'
import { Component } from '@contember/interface'

export const CalCalendarForm = Component(() => (
	<FormLayout>
		<InputField field="secondaryText" label="Title" />
		<InputField field="primaryText" label="Cal.com link" description="Link looks something like this: https://cal.com/example/example-calendar" />
	</FormLayout>
))
